export const AUTH_REASONS = {
  INVALID_TOKEN: 'Invalid_Token',
  REQUEST_VALIDATION: 'Request_Validation',
  TOO_LOGIN_MANY_ATTEMPTS: 'Too_Many_Login_Attempts',
  UNAUTHENTICATED_RETRY_WITH_PII: 'Unauthenticated_Retry_With_PII',
  UNAUTHENTICATED: 'Unauthenticated',
};
